import classes from "./SectionBoxComponent.module.css";

interface Props {
  children: any;
}

export default function SectionBoxComponent(props: Props) {
  return <section className={classes.boxContainer}>{props.children}</section>;
}
